import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { callAPI, handleShare, IsSmallScreen, Method } from "../../../commonFunctions/CommonFunctions";
import PermissionDenied from "../../../commonFunctions/PermissionDenied";
import { AllPermissions } from "../../../commonFunctions/PermissionManger";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import ConfirmDialog, { useConfirmDialog } from "../../../Components/Confirmation/ConfirmDialog";
import { useDispatch } from "react-redux";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { resetDataComponent, storeDataComponent, updateDataComponent } from "../../../StateManagement/actions";
import { useForm } from "react-hook-form";
import PaymentDrawyer from "./DrawyerPages/PaymentDrawyer";
import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";
import DrawyerPartPayment from "../../Notes/DrawyerPartPayment";

export const OverViewInvoices: React.FC<any> = React.memo((props) => {
    const isMobile = IsSmallScreen();
    AllPermissions.getInstance();
    const { add, edit, remove, view } = AllPermissions.getWorkOrderPermission;
    const { showMessage } = useSnackbar();
    const dispatch = useDispatch()
    const { open, title, onConfirm, handleClose, openConfirmDialog, } = useConfirmDialog();
    const navigate = useNavigate();
    const params = useParams();
    const [InvoiceData, setInvoiceData] = useState<any>([])
    const [openF, setOpen] = React.useState(false);
    const [openPart, setOpenPart] = React.useState(false);
    const id = params?.id;
    const [resetLoad, setResetLoad] = useState(false)
    const [formComponent, setFormComponent] = useState<any>()
    const { control, register, handleSubmit, setValue, reset } = useForm();

    useEffect(() => {
        const getInvoices = async () => {
            try {
                setResetLoad(false)
                const response: any = await callAPI(`CRMInvoice/lead/${id}`, Method.GET, null, null);
                setInvoiceData(response?.data || []);
            }
            catch (e) {
            }
        }
        getInvoices();
    }, [resetLoad])
    const columns: IColumns[] = [
        {
            header: "Name",
            fieldName: "customerName",
            tooltip: true,
            type: 'default'
        },
        {
            header: "No",
            fieldName: "invoiceNumber",
            type: 'default'
        },
        {
            header: "Total",
            fieldName: "grandTotal",
            type: 'default',

        },
        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: [edit ? "Edit" : undefined, "Print", "Delete"].filter(Boolean),
            actionCallback: (action, row) => handleAction(action, row),

        },
    ];
    const handleAction = async (action: string, row: any) => {
        if (action === "Edit") {
            navigate(`invoice/${row?.id}`)
        }
        else if (action === "Print") {
            // navigate(`/invoice/print/${row?.id}`);
            window.open(`${window.location.origin}/invoice/print/${row?.id}`, "_blank");
        } else if (action === "Delete") {
            openConfirmDialog("Delete this record?", () => handleDelete(row?.id))
        }
        else if (action === 'Share') {
            handleShare(`/order/print/${row.id}`, 'Work Order');
        }
        else if (action === 'Payment') {

            // const totalIncludedAmount = row?.quotationItems
            //   ?.filter((item: any) => item.isIncluded)
            //   .reduce((sum: number, item: any) => sum + Number(item.totalPrice || 0), 0);
            // const advanceAmount: any = (totalIncludedAmount * 30) / 100;
            const wData: any = { ...row };
            const form: any = <PaymentDrawyer
                id="paymentrawyer"
                data={wData}
                //paymentId={row?.id}
                control={control}
                quatationId={row?.id}
                register={register}
                reset={reset}
                setValue={setValue}
                onCancel={() => { reset(); setOpen(false); setFormComponent(null) }}
            />
            setFormComponent(form)
            setTimeout(() => {
                setOpen(true)
            }, 10);
        }
        // else if (action === 'Part Payment') {
        //   const form: any = <DrawyerPartPayment
        //     id={id}
        //     control={control}
        //     register={register}
        //     InvoiceId={row.id}
        //     reset={reset}
        //     setValue={setValue}
        //     onCancel={() => { reset(); setOpenPart(false); setFormComponent(null) }}

        //   />
        //   setFormComponent(form)
        //   setTimeout(() => {
        //     setOpenPart(true)
        //   }, 10);
        // }
    }
    const handleDelete = async (id?: string | number) => {
        const response: any = await callAPI(`CRMInvoice`, Method.DELETE, null, id);
        dispatch(resetDataComponent('InvoiceGrid'));
        setResetLoad(true)
        if (response?.success) {
            showMessage(response?.message, "success")
        }
        else {
            showMessage(response?.message || 'Something went wrong', "error")
        }
        handleClose()

    };
    // useEffect(() => {
    //     const getQuotations = async () => {
    //         try {
    //             setResetLoad(false)
    //             const response: any = await callAPI(`Invoices/lead/${id}`, Method.GET, null, null);
    //             setInvoiceData(response?.data || []);
    //         }
    //         catch (e) {
    //         }
    //     }
    //     getQuotations();
    // }, [resetLoad])
    const handleInvoiceAddClick = () => {
        navigate(`invoice`)
    }
    const handlePaymentData = async (data: any) => {
        try {
            dispatch(storeDataComponent('paymentSubmit', { loading: true }));
            const response: any = await saveData(data);
            if (response && response?.message) {
                dispatch(resetDataComponent('paymentDealsGrid'));
                reset()
                setResetLoad(true)
                showMessage(response.message, response.success === true ? 'success' : 'error')
            } else if (response?.id) {
                dispatch(resetDataComponent('paymentDealsGrid'));
                setResetLoad(true)
                showMessage('Product Created Successfully', 'success')
            }
        } catch (e: any) {
            showMessage(e.error);
            setResetLoad(false)
        }
        finally {
            dispatch(updateDataComponent('paymentSubmit', { loading: false }));
        }

    }
    const handlePartPaymentData = async (data: any) => {
        try {
            dispatch(storeDataComponent('PartPaymentSubmit', { loading: true }));
            const response: any = await setPartPaymentRequest(data);
            if (response && response?.message) {
                dispatch(resetDataComponent('partPaymentsGrid'));
                reset()
                setResetLoad(true)
                showMessage(response.message, response.success === true ? 'success' : 'error')
            } else if (response?.id) {
                dispatch(resetDataComponent('partPaymentsGrid'));
                setResetLoad(true)
                showMessage('Payment Created Successfully', 'success')
            }
        } catch (e: any) {
            showMessage(e.error);
            setResetLoad(false)
        }
        finally {
            dispatch(updateDataComponent('PartPaymentSubmit', { loading: false }));
        }

    }
    const saveData = async (data: any) => {
        try {
            const request: any = {
                "leadId": id,
                "amountReceived": Number(data?.amountReceived),
                "paymentMethod": data?.paymentMethod,
                "transactionReference": data?.transactionReference,
                "notes": data?.notes,
                workOrderId: data?.quatationId,//for payment
                invoiceNumber: data?.invoiceNumber,
                accountCode: ' ',

            }
            if (data?.paymentId) {

                const response: any = await callAPI(`payment-receives`, Method.PUT, request, data.paymentId);
                return response
            } else {
                const response: any = await callAPI("payment-receives", Method.POST, request);
                return response
            }
        } catch (error) {

        }

    }
    const setPartPaymentRequest = async (data: any) => {
        const request: any = {
            leadId: id,
            workOrderId: data?.workOrderId,
            amount: data?.amount,
            area: data?.area || "",
            description: data?.description,
            date: data?.date
        }
        try {
            const response = await callAPI(`Partpayment`, Method.POST, request);
            return response || ""
        } catch (error) {

        }
    }


    return (

            <Grid container spacing={2} sx={{ marginTop: 0 }}>
                {view ? <Grid item xs={12}>
                    <WSDataGrid
                        id="InvoiceGrid"
                        columns={columns}
                        title="Invoices"
                        data={InvoiceData}
                        gridHeaderSx={{
                            backgroundColor: "#474700",
                            border: "1px solid #474700",
                        }} isAccordian={true}
                        addButtonBgClor={{ bg: '#474725', hovercolor: '#474740' }}
                        addButton={add ? { label: "New", color: "secondary" } : undefined}
                        onAddButtonClick={handleInvoiceAddClick}
                    />
                    {/* <SwipeableDrawerForm anchor="right" title={'Payments'}
                        openForm={openF}
                        formComponent={<form onSubmit={handleSubmit(handlePaymentData)}>
                            {formComponent}
                        </form>}
                        onClose={() => { reset(); setOpen(false); setFormComponent(null) }}
                    />
                    <SwipeableDrawerForm anchor="right" title={'Part Payments'}
                        openForm={openPart}
                        formComponent={<form onSubmit={handleSubmit(handlePartPaymentData)}>
                            {formComponent}
                        </form>}
                        onClose={() => { reset(); setOpenPart(false); setFormComponent(null) }}
                    /> */}
                </Grid>
                    : <PermissionDenied />

                }
                <ConfirmDialog
                    open={open}
                    title={title}
                    onConfirm={onConfirm}
                    onClose={handleClose}
                />
            </Grid>
      
    );
});
